import { Resource as e, API as o } from "@coveo/platform-client";
const s = class s extends e {
  post(t) {
    return this.api.post(this.buildPath(s.baseUrl), { trackingId: t });
  }
};
s.baseUrl = `/rest/organizations/${o.orgPlaceholder}/commerce/v2/setup`;
let r = s;
export {
  r as Setup
};
//# sourceMappingURL=Setup.js.map
